import { mockIntroData } from "../../../mock"
import Footer from "../../footer"
import NavBar from "../../nav"
import './index.scss'

const LevelFlight = () => {
  return <div>
    <NavBar />
    <div className='levelflight__logo' />
    <div className='intro'>
      <div className='levelflight__header'>
        <div className='levelflight__left'>
          <p className='levelflight__left--title'>Introducing LevelFlight</p>
          <p className='levelflight__left--description'>Compliance as a Service (CaaS). Subscription-based Compliance.</p>
          <a href="/contact-us" className="btn primary get-access-now">Get Access Now</a>
        </div>
        <div className='levelflight__right--ipad' />
      </div>
    </div>
    <div className='levelflight__image' />
    <div className='levelflight__grid'>
      {mockIntroData.map((item, idx) => <div key={idx}>
        <div className='levelflight__block-text'>
          <p>{item.title}</p>
          <p>{item.content}</p>
          <p className='levelflight__link'>View More</p>
        </div>
      </div>)}
    </div>
    <Footer />
  </div>
}

export default LevelFlight